import { render, staticRenderFns } from "./parkingDiscount.vue?vue&type=template&id=3bcf00bd&scoped=true&"
import script from "./parkingDiscount.vue?vue&type=script&lang=js&"
export * from "./parkingDiscount.vue?vue&type=script&lang=js&"
import style0 from "./parkingDiscount.vue?vue&type=style&index=0&id=3bcf00bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf00bd",
  null
  
)

export default component.exports